import { MODERNIZED_BLOCK_DIAGRAM_LINE_HEIGHT as LINE_HEIGHT } from '@ardoq/graph-labeling';
import {
  MODERNIZED_BLOCK_DIAGRAM_GROUP_PADDING as PADDING,
  MODERNIZED_BLOCK_DIAGRAM_EXPANDER_SIZE as EXPANDER_SIZE,
  MODERNIZED_BLOCK_DIAGRAM_GROUP_HEADER_ICON_HEIGHT as HEADER_ICON_HEIGHT,
} from 'tabview/blockDiagram/view/yFilesExtensions/modernized/consts';
import { wrapString } from 'tabview/blocks/misc/string';
import { MODERNIZED_BLOCK_DIAGRAM_URL_ICON_SIZE as URL_ICON_SIZE } from 'yfilesExtensions/styles/modernized/consts';

const MAIN_LABEL_HORIZONTAL_MARGIN = 2;
const URL_LABEL_HEADER_WIDTH = URL_ICON_SIZE + MAIN_LABEL_HORIZONTAL_MARGIN;
const EXPANDER_HEADER_WIDTH = EXPANDER_SIZE + MAIN_LABEL_HORIZONTAL_MARGIN;
const REPRESENTATION_HEADER_WIDTH =
  HEADER_ICON_HEIGHT + MAIN_LABEL_HORIZONTAL_MARGIN;
const MAIN_LABEL_MAX_LINES = 3;

type LayoutGroupHeaderLabelsArgs = {
  mainLabel: string;
  nodeWidth: number;
  hasUrlFields: boolean;
  hasRepresentationData: boolean;
  measure: (text: string) => number;
};
const layoutGroupHeaderMainLabel = ({
  mainLabel,
  nodeWidth,
  hasUrlFields,
  hasRepresentationData,
  measure,
}: LayoutGroupHeaderLabelsArgs) => {
  const urlButtonWidth = hasUrlFields ? URL_LABEL_HEADER_WIDTH : 0;
  const representationDataWidth = hasRepresentationData
    ? REPRESENTATION_HEADER_WIDTH
    : 0;
  const availableWidth = nodeWidth - 2 * PADDING;
  const mainLabelAvailableWidth =
    availableWidth -
    EXPANDER_HEADER_WIDTH -
    urlButtonWidth -
    representationDataWidth;
  const wrappedMainLabel = wrapString(
    mainLabel,
    mainLabelAvailableWidth,
    measure,
    MAIN_LABEL_MAX_LINES
  );
  const mainLabelHeight = wrappedMainLabel.length * LINE_HEIGHT;
  return { wrappedMainLabel, mainLabelHeight };
};

export { layoutGroupHeaderMainLabel };
